import { usePostHog } from "posthog-js/react";
import { useLocation } from "react-router";
import { useEffect } from "react";
import type { PostHogInitConfig } from "@wayflyer/blackbox-fe";

const PROD = import.meta.env.PROD;

const POSTHOG_KEY = "phc_5Ye2r14imIkan5Ea4FURNXcLdrUt6Ztf6ouzNppU5cn";
export const POSTHOG_DEV_KEY = "phc_1SUEXzRAezj8infuQ9i1DGZdpmrY8uPvXWPeoXjpJDx";

interface PostHogConfigOptions {
  flagsApiHost?: string;
}

const env = PROD && !window.origin.includes("dev") ? "prod" : "local";
const e2eFlagsApiHost = import.meta.env.MODE === "test" ? window.location.origin : undefined;

const searchParams = new URLSearchParams(window.location.href);
const distinctID = searchParams.get("distinct_id") ?? undefined;
const sessionID = searchParams.get("session_id") ?? undefined;

const getPostHogConfig = ({ flagsApiHost = e2eFlagsApiHost }: PostHogConfigOptions = {}) =>
  ({
    token: env === "prod" ? POSTHOG_KEY : POSTHOG_DEV_KEY,
    bootstrap: {
      distinctID,
      sessionID,
    },
    ...(flagsApiHost ? { flags_api_host: flagsApiHost } : {}),
  } satisfies PostHogInitConfig);

export const posthogConfig = getPostHogConfig({ flagsApiHost: e2eFlagsApiHost });

export function usePostHogPageView() {
  const location = useLocation();
  const posthog = usePostHog();
  useEffect(() => {
    if (posthog) {
      posthog.capture("$pageview");
    }
  }, [location, posthog]);
}
